import { AppDomain } from '@browsing/config';

export const OTHER_SIZES = 'other';

export const ARTICLE_STATUS_RESERVED = 'RESERVED';
export const ARTICLE_STATUS_SOLD_OUT = 'SOLD_OUT';
export const ARTICLE_STATUS_AVAILABLE = 'AVAILABLE';

export const ADD_CART_MAX_SIMPLES_PER_CONFIG = 501;
export const ADD_CART_MAX_30_SIMPLES_IN_CART = 510;
export const ADD_CART_MAX_SIMPLES_PER_CONFIG_REACHED_QTY_ADJUSTED = 502;
export const ADD_CART_STOCK_NOT_FOUND = 503;
export const ADD_CART_MAX_AVAILABLE_STOCK_REACHED_QTY_ADJUSTED = 504;
export const ADD_CART_NOT_COMBINABLE_ADD_ITEM_NOT_COMBINABLE = 505;
export const ADD_CART_SIZE_SELECTION_WARNING = 506;
export const ADD_CART_VOUCHER_DISABLED = 507;
export const ADD_CART_NOT_COMBINABLE_NOT_COMBINABLE_IN_CART = 508;
export const ADD_CART_SIZE_SELECTION_ERROR = 509;

export const FLASH_MESSAGE_TYPE_SUCCESS = 'success';
export const FLASH_MESSAGE_TYPE_ERROR = 'error';
export const FLASH_MESSAGE_TYPE_WARNING = 'warning';

export const ARTICLE_PRICE_SUPERSCRIPT = '1';
export const ARTICLE_PRICE_SUPERSCRIPT_RRP = '*';

export const MYLOUNGE_ROUTE = '/event';

export const SHOWSTOPPER_FIXED_POSITION = 4;

export const TRACK_DATA = 'TRACK_DATA';
export const TRACK_RECO_NO_RECO = 0;
export const TRACK_RECO_COLLABORATIVE = 1;
export const TRACK_RECO_TOPSELLER = 2;
export const TRACK_RECO_CAMPAIGN_OVERVIEW = 3;

export const TRACK_TRAFFIC_SOURCES = ['notification'];

export const TWENTY_FOUR_HOURS_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const CANCELLED_REQUEST = 'CANCELLED_REQUEST';

export const NON_APPLICABLE = 'N/A';

export const WEBVIEWS_ROUTE_HOME = 'zlounge://home';
export const SPECIAL_COUPON_ERROR_HEADER = 'SPECIAL_COUPON_ERROR_HEADER';

// last chance
export const LASTCHANCE_TAB_ID_DACH = 280;
export const LASTCHANCE_TAB_FR_BEFR_CHFR = 282;
export const LASTCHANCE_TAB_NL_BENL = 284;
export const LASTCHANCE_TAB_COM_UK = 286;
export const LASTCHANCE_TAB_IT = 288;
export const LASTCHANCE_TAB_PL = 290;
export const LASTCHANCE_TAB_ES = 1000;
export const LASTCHANCE_TAB_CZ = 1001;

export const APPDOMAIN_TO_TAB_ID_MAP: Record<
    Exclude<AppDomain, 60 | 61 | 62 | 63 | 66 | 67 | 70 | 71>,
    number
> = {
    [AppDomain.Germany]: LASTCHANCE_TAB_ID_DACH,
    [AppDomain.France]: LASTCHANCE_TAB_FR_BEFR_CHFR,
    [AppDomain.Netherlands]: LASTCHANCE_TAB_NL_BENL,
    [AppDomain.Belgium]: LASTCHANCE_TAB_NL_BENL,
    [AppDomain.BelgiumFR]: LASTCHANCE_TAB_FR_BEFR_CHFR,
    [AppDomain.Austria]: LASTCHANCE_TAB_ID_DACH,
    [AppDomain.Switzerland]: LASTCHANCE_TAB_ID_DACH,
    [AppDomain.SwitzerlandFR]: LASTCHANCE_TAB_FR_BEFR_CHFR,
    [AppDomain.GreatBritain]: LASTCHANCE_TAB_COM_UK,
    [AppDomain.Italy]: LASTCHANCE_TAB_IT,
    [AppDomain.Poland]: LASTCHANCE_TAB_PL,
    [AppDomain.Spain]: LASTCHANCE_TAB_ES,
    [AppDomain.CzechRepublic]: LASTCHANCE_TAB_CZ,
};

export const SEC_SUB_SUCCESS_PLACEMENT = 'SUCCESS_PLACEMENT';

export const RECO_ITEM_WIDTH = 220;

// TODO: Move to some delivery promise helper.
// xmas special
export const XMAS_EVENT_DELIVERY_PROMISE = 'event_delivery_promise_christmas';
export const VALENTINE_EVENT_DELIVERY_PROMISE = 'event_delivery_promise_valentines_day';
